import remarkParse from './lib/index.js';
export default remarkParse;